/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PatientDistributionFilter } from './patientDistributionFilter';
import { PatientDistributionType } from './patientDistributionType';

export interface PatientDistribution { 
    distribution_type: PatientDistributionType;
    distribution_filter: PatientDistributionFilter;
    value: string;
}